module.exports = {
  ModuleName: 'Название модуля',
  OperationChangeTime: 'Время изменения операции',
  Operator: 'Исполнитель',
  To: 'До',
  Close: 'Закрыть',
  SerialNumber: 'Серийный номер',
  OperationTime: 'Время операции',
  QueryScheme: 'Схема запроса',
  QuickSearchBusinessCode: 'Быстрый поиск: номер операции',
  YouDidntOpen: 'У вас нет доступа',
  FinancialAudit: 'Финансовая проверка',
  ModulePermissions: 'Права доступа к модулю',
  IfTheDataLoadingYears: 'Если выбранный диапазон дат превышает 2 года, это повлияет на скорость загрузки данных. Вы уверены, что хотите запросить данные за пределами двух лет?',
  StartDate: 'Дата начала',
  EndDate: 'Дата окончания',
  ContentDescription: 'Описание содержания',
  Name: 'Название'
}
